// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__3pVqG","employee-header-item":"Header_employee-header-item__BGeke"};